<template>
    <div>
        <div v-if="isChildList" class="d-flex align-items-center">
            <div><strong>{{table.name}}</strong></div>

            <div v-if="authorized" class="my-1 ms-2">
                <router-link v-if="hasFormView" class="btn btn-sm btn-primary"
                             :to="{ name: 'view-renderer', params: {id: formView.id}, query: {p: parentDocumentId}}">
                    new {{table.label}}
                </router-link>

                <router-link v-else
                        :to="{ name: 'new-child-object', params: {
                            table_id: table.id,
                            parent_table_id: parentTableId,
                            parent_document_id: parentDocumentId,
                            parentDocument: this.parentDocument,
                        }}"
                        class="btn btn-sm btn-primary">
                    new {{table.label}}
                </router-link>
            </div>
        </div>

        <div v-else class="d-flex align-items-center">

            <div class="my-1 ms-2">
                <router-link v-if="hasFormView" :to="{ name: 'view-renderer', params: {id: formView.id}}" class="btn btn-sm btn-primary">
                    new {{table.label}}
                </router-link>

                <router-link v-else :to="{ name: 'new-object', params: {table_id: table.id, app_id: model.app.id}}" class="btn btn-sm btn-primary">
                    new {{table.label}}
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: 'ViewHeader',
        props: ['view', 'table', 'parentTable', 'parentDocument'],
        computed: {
            isChildList() {
                return this.parentTable && this.parentDocument ? true : false
            },
            authorized() {
                return webase.managers.permission.fullAccess() || webase.managers.permission.authorized(this.parentTable, this.parentDocument)
            },
            parentTableId() {
                return this.parentTable ? this.parentTable.id : null
            },
            parentDocumentId() {
                return this.parentDocument ? this.parentDocument['id'] : null
            },
            hasFormView() {
                return webase.utils.table.hasFormView(this.table)
            },
            formView() {
                return webase.utils.table.getFormView(this.table)
            }
        },
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
